import React from 'react';
import { WHATSAPP_SUPPORT_PHONE } from 'constants/global';
import membershipSupportBannerImg from 'assets/images/membership/membership-support-banner.png';
import './MembershipSupportBanner.scss';

const WHATSAPP_SUPPORT_URL = `https://api.whatsapp.com/send?phone=${WHATSAPP_SUPPORT_PHONE}`;

const MembershipSupportBanner: React.FC = () => {
  return (
    <div className="membership-support-banner">
      <div className="membership-support-banner__content">
        <div className="membership-support-banner__copy">
          <h2 className="membership-support-banner__title">
            <span className="membership-support-banner__title-line">Too Busy or Don't Have the </span>
            <span className="membership-support-banner__title-line">Right Team? Leave It To Us</span>
          </h2>
          <p className="membership-support-banner__description">
            From creative strategy to content production and full-scale influencer seeding campaigns, our
            in-house creative team can handle it all.
          </p>
        </div>
        <a
          className="membership-support-banner__cta"
          href={WHATSAPP_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Talk to us
        </a>
      </div>
      <div className="membership-support-banner__media">
        <img
          className="membership-support-banner__image"
          src={membershipSupportBannerImg}
          alt="Creative team planning campaigns, content, and influencer collaborations"
        />
      </div>
    </div>
  );
};

export default MembershipSupportBanner;
